import { render, staticRenderFns } from "./Whatsapp.vue?vue&type=template&id=e7140aec&scoped=true"
import script from "./Whatsapp.vue?vue&type=script&lang=js"
export * from "./Whatsapp.vue?vue&type=script&lang=js"
import style0 from "./Whatsapp.vue?vue&type=style&index=0&id=e7140aec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7140aec",
  null
  
)

export default component.exports